/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
import * as Types from '@/shared/types/types.generated';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseIntegrationApi } from '../../base-api';
export type IntegrationUserInfoFragment = { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean };

export type IntegrationFragment = { __typename: 'IntegrationResponseType', name: string, integrationId: string, groupId?: string, description?: string, integrationType: Types.IntegrationTypeEnum, status: Types.IntegrationStatusEnum, creationUserId?: string, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, metaData: { __typename: 'GitHubIntegrationConfigType', installationId?: number, oauthStatus: string, isOrganization: boolean, ownerName?: string, ownerId?: number, ownerType?: string } };

export type GitRepositoryFragment = { __typename: 'GitRepositoryResponseType', gitRepositoryId: string, name: string, integrationId: string, objectVersion?: number, gitRepositoryUrl: string };

export type CreateIntegrationMutationVariables = Types.Exact<{
  integration: Types.CreateIntegrationInput;
}>;


export type CreateIntegrationMutation = { __typename: 'Mutation', createIntegration: { __typename: 'IntegrationResponseType', integrationId: string } };

export type UpdateIntegrationMutationVariables = Types.Exact<{
  integrationId: Types.Scalars['String']['input'];
  integration: Types.UpdateIntegrationInput;
}>;


export type UpdateIntegrationMutation = { __typename: 'Mutation', updateIntegration: { __typename: 'IntegrationResponseType', integrationId: string, groupId?: string } };

export type DeleteIntegrationMutationVariables = Types.Exact<{
  integrationId: Types.Scalars['String']['input'];
}>;


export type DeleteIntegrationMutation = { __typename: 'Mutation', deleteIntegration: { __typename: 'IntegrationResponseType', integrationId: string } };

export type SyncIntegrationMutationVariables = Types.Exact<{
  integrationId: Types.Scalars['String']['input'];
}>;


export type SyncIntegrationMutation = { __typename: 'Mutation', syncIntegration: { __typename: 'IntegrationResponseType', integrationId: string } };

export type UpdateGitRepositoryMutationVariables = Types.Exact<{
  gitRepositoryId: Types.Scalars['String']['input'];
  gitRepository: Types.UpdateGitRepositoryInput;
}>;


export type UpdateGitRepositoryMutation = { __typename: 'Mutation', updateGitRepository: { __typename: 'GitRepositoryResponseType', gitRepositoryId: string } };

export type ReadAllIntegrationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.IntegrationFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllIntegrationsQuery = { __typename: 'Query', readAllIntegrations: { __typename: 'PaginatedIntegrationResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'IntegrationResponseType', name: string, integrationId: string, groupId?: string, description?: string, integrationType: Types.IntegrationTypeEnum, status: Types.IntegrationStatusEnum, creationUserId?: string, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, metaData: { __typename: 'GitHubIntegrationConfigType', installationId?: number, oauthStatus: string, isOrganization: boolean, ownerName?: string, ownerId?: number, ownerType?: string } }> } };

export type GenerateGithubInstallUrlQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  flow?: Types.InputMaybe<Types.Scalars['String']['input']>;
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GenerateGithubInstallUrlQuery = { __typename: 'Query', generateGithubInstallUrl: { __typename: 'GithubInstallUrlType', authorizationUrl: string, state: string, flow: string } };

export type ReadAllGitRepositoriesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.GitRepositoryFilterInput>;
}>;


export type ReadAllGitRepositoriesQuery = { __typename: 'Query', readAllGitRepositories: { __typename: 'PaginatedGitRepositoryResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'GitRepositoryResponseType', gitRepositoryId: string, name: string, integrationId: string, objectVersion?: number, gitRepositoryUrl: string }> } };

export type ReadAllIntegrationNamesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadAllIntegrationNamesQuery = { __typename: 'Query', readAllIntegrations: { __typename: 'PaginatedIntegrationResponseType', items: Array<{ __typename: 'IntegrationResponseType', name: string, integrationId: string }> } };

export type ReadGitHubRepositoryQueryVariables = Types.Exact<{
  gitRepositoryId: Types.Scalars['String']['input'];
}>;


export type ReadGitHubRepositoryQuery = { __typename: 'Query', readGitRepository: { __typename: 'GitRepositoryResponseType', gitRepositoryId: string, name: string, integrationId: string, objectVersion?: number, gitRepositoryUrl: string } };

export type ReadGroupedIntegrationsCountQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type ReadGroupedIntegrationsCountQuery = { __typename: 'Query', readAllIntegrations: { __typename: 'PaginatedIntegrationResponseType', itemCount: number } };

export type ReadUngroupedIntegrationsCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadUngroupedIntegrationsCountQuery = { __typename: 'Query', readAllIntegrations: { __typename: 'PaginatedIntegrationResponseType', itemCount: number } };

export type ReadGroupedIntegrationCountsQueryVariables = Types.Exact<{
  groupIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadGroupedIntegrationCountsQuery = { __typename: 'Query', readGroupedIntegrationCounts: Array<{ __typename: 'GroupedIntegrationCountResponseType', groupId: string, count: number }> };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const IntegrationUserInfoFragmentDoc = new TypedDocumentString(`
    fragment IntegrationUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
    `, {"fragmentName":"IntegrationUserInfo"});
export const IntegrationFragmentDoc = new TypedDocumentString(`
    fragment Integration on IntegrationResponseType {
  __typename
  name
  integrationId
  groupId
  description
  integrationType
  status
  creationUserId
  creationTimestamp
  creationUser {
    __typename
    ...IntegrationUserInfo
  }
  metaData {
    __typename
    installationId
    oauthStatus
    isOrganization
    ownerName
    ownerId
    ownerType
  }
  objectVersion
}
    fragment IntegrationUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`, {"fragmentName":"Integration"});
export const GitRepositoryFragmentDoc = new TypedDocumentString(`
    fragment GitRepository on GitRepositoryResponseType {
  __typename
  gitRepositoryId
  name
  integrationId
  objectVersion
  gitRepositoryUrl
}
    `, {"fragmentName":"GitRepository"});
export const CreateIntegrationDocument = new TypedDocumentString(`
    mutation CreateIntegration($integration: CreateIntegrationInput!) {
  __typename
  createIntegration(integration: $integration) {
    __typename
    integrationId
  }
}
    `);
export const UpdateIntegrationDocument = new TypedDocumentString(`
    mutation UpdateIntegration($integrationId: String!, $integration: UpdateIntegrationInput!) {
  __typename
  updateIntegration(integrationId: $integrationId, integration: $integration) {
    __typename
    integrationId
    groupId
  }
}
    `);
export const DeleteIntegrationDocument = new TypedDocumentString(`
    mutation DeleteIntegration($integrationId: String!) {
  __typename
  deleteIntegration(integrationId: $integrationId) {
    __typename
    integrationId
  }
}
    `);
export const SyncIntegrationDocument = new TypedDocumentString(`
    mutation SyncIntegration($integrationId: String!) {
  __typename
  syncIntegration(integrationId: $integrationId) {
    __typename
    integrationId
  }
}
    `);
export const UpdateGitRepositoryDocument = new TypedDocumentString(`
    mutation UpdateGitRepository($gitRepositoryId: String!, $gitRepository: UpdateGitRepositoryInput!) {
  __typename
  updateGitRepository(
    gitRepositoryId: $gitRepositoryId
    gitRepository: $gitRepository
  ) {
    __typename
    gitRepositoryId
  }
}
    `);
export const ReadAllIntegrationsDocument = new TypedDocumentString(`
    query ReadAllIntegrations($filter: IntegrationFilterInput, $pagination: PaginationInput) {
  __typename
  readAllIntegrations(filter: $filter, pagination: $pagination) {
    __typename
    items {
      __typename
      ...Integration
    }
    pages
    itemCount
  }
}
    fragment IntegrationUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Integration on IntegrationResponseType {
  __typename
  name
  integrationId
  groupId
  description
  integrationType
  status
  creationUserId
  creationTimestamp
  creationUser {
    __typename
    ...IntegrationUserInfo
  }
  metaData {
    __typename
    installationId
    oauthStatus
    isOrganization
    ownerName
    ownerId
    ownerType
  }
  objectVersion
}`);
export const GenerateGithubInstallUrlDocument = new TypedDocumentString(`
    query GenerateGithubInstallUrl($tenantId: String!, $flow: String, $name: String) {
  __typename
  generateGithubInstallUrl(tenantId: $tenantId, flow: $flow, name: $name) {
    __typename
    authorizationUrl
    state
    flow
  }
}
    `);
export const ReadAllGitRepositoriesDocument = new TypedDocumentString(`
    query ReadAllGitRepositories($filter: GitRepositoryFilterInput) {
  __typename
  readAllGitRepositories(filter: $filter) {
    __typename
    items {
      __typename
      ...GitRepository
    }
    pages
    itemCount
  }
}
    fragment GitRepository on GitRepositoryResponseType {
  __typename
  gitRepositoryId
  name
  integrationId
  objectVersion
  gitRepositoryUrl
}`);
export const ReadAllIntegrationNamesDocument = new TypedDocumentString(`
    query ReadAllIntegrationNames {
  __typename
  readAllIntegrations {
    __typename
    items {
      __typename
      name
      integrationId
    }
  }
}
    `);
export const ReadGitHubRepositoryDocument = new TypedDocumentString(`
    query ReadGitHubRepository($gitRepositoryId: String!) {
  __typename
  readGitRepository(gitRepositoryId: $gitRepositoryId) {
    __typename
    ...GitRepository
  }
}
    fragment GitRepository on GitRepositoryResponseType {
  __typename
  gitRepositoryId
  name
  integrationId
  objectVersion
  gitRepositoryUrl
}`);
export const ReadGroupedIntegrationsCountDocument = new TypedDocumentString(`
    query ReadGroupedIntegrationsCount($groupId: String!) {
  __typename
  readAllIntegrations(filter: {groupId: {contains: $groupId}}) {
    __typename
    itemCount
  }
}
    `);
export const ReadUngroupedIntegrationsCountDocument = new TypedDocumentString(`
    query ReadUngroupedIntegrationsCount {
  __typename
  readAllIntegrations(filter: {groupId: {doNotIgnoreNullable: [eq]}}) {
    __typename
    itemCount
  }
}
    `);
export const ReadGroupedIntegrationCountsDocument = new TypedDocumentString(`
    query ReadGroupedIntegrationCounts($groupIds: [String!]!) {
  __typename
  readGroupedIntegrationCounts(groupIds: $groupIds) {
    __typename
    groupId
    count
  }
}
    `);

const injectedRtkApi = baseIntegrationApi.injectEndpoints({
  overrideExisting: isHotReloadEnabled && module.hot?.status() === "apply",
  endpoints: (build) => ({
    CreateIntegration: build.mutation<Types.CreateIntegrationMutation, Types.CreateIntegrationMutationVariables>({
      query: (variables) => ({ document: CreateIntegrationDocument as unknown as string, variables })
    }),
    UpdateIntegration: build.mutation<Types.UpdateIntegrationMutation, Types.UpdateIntegrationMutationVariables>({
      query: (variables) => ({ document: UpdateIntegrationDocument as unknown as string, variables })
    }),
    DeleteIntegration: build.mutation<Types.DeleteIntegrationMutation, Types.DeleteIntegrationMutationVariables>({
      query: (variables) => ({ document: DeleteIntegrationDocument as unknown as string, variables })
    }),
    SyncIntegration: build.mutation<Types.SyncIntegrationMutation, Types.SyncIntegrationMutationVariables>({
      query: (variables) => ({ document: SyncIntegrationDocument as unknown as string, variables })
    }),
    UpdateGitRepository: build.mutation<Types.UpdateGitRepositoryMutation, Types.UpdateGitRepositoryMutationVariables>({
      query: (variables) => ({ document: UpdateGitRepositoryDocument as unknown as string, variables })
    }),
    ReadAllIntegrations: build.query<Types.ReadAllIntegrationsQuery, Types.ReadAllIntegrationsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllIntegrationsDocument as unknown as string, variables })
    }),
    GenerateGithubInstallUrl: build.query<Types.GenerateGithubInstallUrlQuery, Types.GenerateGithubInstallUrlQueryVariables>({
      query: (variables) => ({ document: GenerateGithubInstallUrlDocument as unknown as string, variables })
    }),
    ReadAllGitRepositories: build.query<Types.ReadAllGitRepositoriesQuery, Types.ReadAllGitRepositoriesQueryVariables | void>({
      query: (variables) => ({ document: ReadAllGitRepositoriesDocument as unknown as string, variables })
    }),
    ReadAllIntegrationNames: build.query<Types.ReadAllIntegrationNamesQuery, Types.ReadAllIntegrationNamesQueryVariables | void>({
      query: (variables) => ({ document: ReadAllIntegrationNamesDocument as unknown as string, variables })
    }),
    ReadGitHubRepository: build.query<Types.ReadGitHubRepositoryQuery, Types.ReadGitHubRepositoryQueryVariables>({
      query: (variables) => ({ document: ReadGitHubRepositoryDocument as unknown as string, variables })
    }),
    ReadGroupedIntegrationsCount: build.query<Types.ReadGroupedIntegrationsCountQuery, Types.ReadGroupedIntegrationsCountQueryVariables>({
      query: (variables) => ({ document: ReadGroupedIntegrationsCountDocument as unknown as string, variables })
    }),
    ReadUngroupedIntegrationsCount: build.query<Types.ReadUngroupedIntegrationsCountQuery, Types.ReadUngroupedIntegrationsCountQueryVariables | void>({
      query: (variables) => ({ document: ReadUngroupedIntegrationsCountDocument as unknown as string, variables })
    }),
    ReadGroupedIntegrationCounts: build.query<Types.ReadGroupedIntegrationCountsQuery, Types.ReadGroupedIntegrationCountsQueryVariables>({
      query: (variables) => ({ document: ReadGroupedIntegrationCountsDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateIntegrationMutation, useUpdateIntegrationMutation, useDeleteIntegrationMutation, useSyncIntegrationMutation, useUpdateGitRepositoryMutation, useReadAllIntegrationsQuery, useLazyReadAllIntegrationsQuery, useGenerateGithubInstallUrlQuery, useLazyGenerateGithubInstallUrlQuery, useReadAllGitRepositoriesQuery, useLazyReadAllGitRepositoriesQuery, useReadAllIntegrationNamesQuery, useLazyReadAllIntegrationNamesQuery, useReadGitHubRepositoryQuery, useLazyReadGitHubRepositoryQuery, useReadGroupedIntegrationsCountQuery, useLazyReadGroupedIntegrationsCountQuery, useReadUngroupedIntegrationsCountQuery, useLazyReadUngroupedIntegrationsCountQuery, useReadGroupedIntegrationCountsQuery, useLazyReadGroupedIntegrationCountsQuery } = injectedRtkApi;

